import { render } from "./ConfirmActionModal.vue?vue&type=template&id=0298f046"
import script from "./ConfirmActionModal.vue?vue&type=script&lang=js"
export * from "./ConfirmActionModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ConfirmActionModal.vue"]])

export default __exports__